import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';

import Default from "./layouts/Default.vue";
import NoSidebar from "./layouts/NoSidebar.vue";
import BlueBackground from "./layouts/BlueBackground.vue";

Vue.component("default-layout", Default);
Vue.component("no-sidebar-layout", NoSidebar);
Vue.component("blue-background-layout", BlueBackground);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
